import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { animations, dimensions, timing } from "@styles";

export const attachment = (theme: Theme) => css`
  ${animations.transition(undefined, timing.moderatelySlow)};
  border: 1px solid ${theme.system.borderBase};
  border-radius: ${borders.radiusBase};
  padding: 0;
  width: auto;
  overflow: hidden;

  display: inline-flex;
  justify-content: flex-start;
  align-items: stretch;

  &:hover {
    border: 1px solid ${theme.system.borderHover};
  }
`;

export const attachmentIsWide = css`
  width: 12.5rem;
  overflow: hidden;
  justify-content: space-between;
`;

export const attachmentIsFullWidth = css`
  width: 100%;
  overflow: hidden;
  justify-content: space-between;
`;

export const iconWrapper = css`
  margin-right: 0.75rem;
`;

export const attachmentArea = css`
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex: 1;
  }
`;

export const buttonIsWide = css`
  width: 9.75rem;
`;

export const buttonIsFullWidth = css`
  width: 100%;
`;

export const documentInfo = css`
  text-align: left;
  width: calc(100% - 2.75rem); // 2.75rem from margin-right and width of icon container
`;

export const truncate = css`
  max-width: 9.75rem; //12.5rem - 2.75rem from the margin-right and width of icon container
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const truncateFullWidth = css`
  width: 95%;
  margin-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const showLabel = css`
  max-width: none;
`;

export const removableArea = (theme: Theme) => css`
  ${animations.transition()};
  position: relative;
  padding: 0.5rem 0.75rem;
  height: auto;
  cursor: pointer;
  display: flex;
  align-items: center;

  appearance: none;
  border: none;

  path {
    fill: ${theme.system.textBase};
  }

  &:active {
    background-color: ${theme.system.backgroundMutedHover};

    path {
      fill: ${theme.system.textActive};
    }
  }

  &:before {
    content: "";
    background-color: ${theme.separator.base};
    position: absolute;
    height: 70%;
    left: -1px;
    width: 1px;
    top: 15%;
  }
`;

export const showMore = css`
  cursor: pointer;
`;
